"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _container = _interopRequireDefault(require("../container"));

var _index = _interopRequireDefault(require("./index.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

// Landing page footer
// ===================
var LandingFooter = function LandingFooter(_ref) {
  var type = _ref.type,
      className = _ref.className,
      children = _ref.children;
  return _react["default"].createElement("footer", {
    className: (0, _classnames["default"])(_index["default"].LandingFooter, className)
  }, _react["default"].createElement(_container["default"], {
    type: type
  }, _react["default"].Children.map(children, function (child) {
    return _react["default"].cloneElement(child, {
      className: (0, _classnames["default"])(_index["default"].entry, (0, _defineProperty2["default"])({}, _index["default"].entryLink, child.type === 'a'))
    });
  })));
};

LandingFooter.propTypes = {
  type: _propTypes["default"].string,
  className: _propTypes["default"].string,
  children: _propTypes["default"].node
};
LandingFooter.defaultProps = {
  type: 'full'
};
var _default = LandingFooter;
exports["default"] = _default;